import React, {Component} from 'react';


class HeroLayer extends Component {

	
    render () {
        return (
         
            <div className={ `hlayer ${this.props.classes}` } style={this.props.styleOuter}>
            	<div className="hlayer__inner" style={this.props.styleInner}>
          			{this.props.children}
          		</div>
            </div>

        );
    }
}

export default HeroLayer;


// WEBPACK FOOTER //
// ./src/containers/Hero/HeroLayer.js